import {useLayoutEffect, useState} from 'react';

/** Embedded/resizeable panes keep their owner's sizing; full-page Chat follows the visible viewport. */
export default function useChatViewport(containerRef, variant) {
    const [height, setHeight] = useState(undefined);
    useLayoutEffect(() => {
        if (variant !== 'page') return undefined;
        let frame = 0;
        const update = () => {
            cancelAnimationFrame(frame);
            frame = requestAnimationFrame(() => {
                if (!containerRef.current) return;
                const viewport = window.visualViewport;
                const bottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight;
                const next = Math.max(0, Math.floor(bottom - containerRef.current.getBoundingClientRect().top));
                setHeight(current => current === next ? current : next);
            });
        };
        update();
        const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(update);
        if (containerRef.current?.parentElement) observer?.observe(containerRef.current.parentElement);
        window.addEventListener('resize', update);
        window.visualViewport?.addEventListener('resize', update);
        window.visualViewport?.addEventListener('scroll', update);
        return () => {
            cancelAnimationFrame(frame); observer?.disconnect();
            window.removeEventListener('resize', update);
            window.visualViewport?.removeEventListener('resize', update);
            window.visualViewport?.removeEventListener('scroll', update);
        };
    }, [containerRef, variant]);
    return variant === 'page' ? height : undefined;
}
